module.exports = __webpack_public_path__ + "img/fulweb2.0-coloured.de0fa9ed.svg";